// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { IStartAccountDeletionPayload, IFinishAccountDeletionPayload } from "models/interfaces";

export const startAccountDeletion = createAsyncThunk(
  "accountDeletion/startAccountDeletion",
  async (data: IStartAccountDeletionPayload) => {
    try {
      const response = await REST.post("/user/start-account-deletion", data);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const finishAccountDeletion = createAsyncThunk(
  "accountDeletion/finishAccountDeletion",
  async (data: IFinishAccountDeletionPayload) => {
    try {
      const response = await REST.post("/user/finish-account-deletion", data);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);